export default __webpack_public_path__ + "static/media/movie-round-a-voter.83ef021d.svg";